import { WebRoutes } from "consts/enpoints/web";
import { convertToBooleanSwitch } from "util/transformers";
import type { HighRiskMerchant as HighRiskMerchantType } from "features/ecommerce/types";
import { HighRiskMerchant as HighRiskMerchantApi } from "features/ecommerce/api";
import { HighRiskMerchant } from "ui/forms/ECommerce";
import { useOnboardingForm, useOnboardingStepData } from "ui/organizms/ECommerce/Onboarding/common";
import { useOnboardingApplication } from "../../hooks";

export const useRiskAndCompliance = () => {
    const { getApplicationModel } = useOnboardingApplication();

    const { data } = useOnboardingStepData<HighRiskMerchantType.OnboardingRiskAndCompliance>();

    const withValues = useOnboardingForm({
        save: HighRiskMerchantApi.putOnboardingsHighRiskComplianceSteps,
        route: WebRoutes.Onboarding.HighRiskMerchant,
        getApplicationModel
    });

    const formProps: HighRiskMerchant.RiskAndCompliance.OnboardingRiskAndComplianceForm = {
        bootstrapData: {},
        initialValues: HighRiskMerchant.RiskAndCompliance.getInitialValues(data),
        isBootstrapDataLoading: false,
        onSaveOrCreate: ({
            hasCreditLimitPolicy,
            creditLimitPolicyInput,
            fraudToolsInput,
            hasTerminationHistory,
            terminationHistoryInput,
            kycProviderInput,
            refundChargebackPolicyInput,
            securityFeaturesInput,
            hasSsl,
            additionalRiskInput
        }, helpers) => (
            withValues({
                creditLimitPolicyInput,
                fraudToolsInput,
                terminationHistoryInput,
                kycProviderInput,
                refundChargebackPolicyInput,
                securityFeaturesInput,
                additionalRiskInput,
                hasCreditLimitPolicy: convertToBooleanSwitch(hasCreditLimitPolicy),
                hasTerminationHistory: convertToBooleanSwitch(hasTerminationHistory),
                hasSsl: convertToBooleanSwitch(hasSsl)
            }, helpers)
        )
    };

    return {
        ...formProps,
        ...HighRiskMerchant.RiskAndCompliance.useForm(formProps),
        ...data
    };
};

export default useRiskAndCompliance;
